import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const cancelDeliveryNote = createAction(ACTION.CANCEL_DELIVERY_NOTE.REQUEST, (deliveryNoteId) => ({deliveryNoteId}));
export const beginCancelDeliveryNote = createAction(ACTION.BEGIN_CANCEL_DELIVERY_NOTE, () => {});
export const endCancelDeliveryNote = createAction(ACTION.END_CANCEL_DELIVERY_NOTE, () => {});
export const successCancelDeliveryNote = createAction(ACTION.CANCEL_DELIVERY_NOTE.SUCCESS);
